const BaseRoutes = {
  base: "",
  login: "login",
  contracts: "contracts",
  bids: "bids",
  changePassword: "change-password",
  uploadingAnOffer: "uploading-an-offer",
  users: "users",
  info: "info",
  reports: "reports",
  companies: "companies",
  settings: "settings",
  profile: "profile",
  pendingActions: "pending-actions",
  bidsWithBalance: "bids-with-balance",
  markdownGuide: "markdown-guide",
  amlChecks: "aml-checks",
  nominalAccount: "nominal-account",
  interfaceCustomization: "interface-customization",
  documentTemplates: "document-templates",
  messageTemplates: "message-templates",
  hintsManagement: "hints-management",
  walletsWhitelist: "wallets-whitelist",
};

const basename = window.injectedEnv?.WE_ENV_BASE_PATH;
const isBaseNameValid = typeof basename === "string" && !!basename.length;

export const routes = !isBaseNameValid
  ? BaseRoutes
  : Object.entries(BaseRoutes).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: [basename, value].join("/"),
      }),
      {} as typeof BaseRoutes
    );
